import React, {useEffect, useRef, useState} from 'react'
import {CustomerModelTahsilat, CustomerModelTahsilatModal} from '../../../../types'
import './modal.css'

interface Props {
  bills: any
  customer: any
  selectedDebt: any
  setSelectedDebt: any
}

const ModalBillTable: React.FC<Props> = ({bills, customer, selectedDebt, setSelectedDebt}) => {
  const selectAll: HTMLInputElement = document.getElementById('selectAll') as HTMLInputElement

  const [sortedColumn, setSortedColumn] = React.useState<string>('')
  const [sortedData, setSortedData] = React.useState<any[]>([])
  const [sortOrder, setSortOrder] = useState('asc')

  const handleSum = (e: any) => {
    if (e.target.checked === true) {
      setSelectedDebt(selectedDebt + parseFloat(e.target.value))
    } else {
      setSelectedDebt(selectedDebt - parseFloat(e.target.value))
    }
  }

  let billCheckbox = document.getElementsByName('bills')

  useEffect(() => {
    billCheckbox.forEach((element: HTMLElement) => {
      let elm: any = element
      let elm2: HTMLInputElement = elm
      if (!elm2.checked) {
        selectAll.checked = false
      }
    })
  }, [selectedDebt])

  const handleAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    for (let i = 0; i < billCheckbox.length; i++) {
      let checkbox = billCheckbox[i] as HTMLInputElement
      checkbox.checked = event.target.checked
    }
    let temp = 0
    if (event.target.checked) {
      billCheckbox.forEach((element: HTMLElement) => {
        if (
          element &&
          element.hasAttribute('value') &&
          element.getAttribute('value') &&
          element.getAttribute('value')?.toString()
        ) {
          let temp2: any = element.getAttribute('value')
          let tempsec: string = temp2.toString()
          temp += +tempsec
        }
      })
      setSelectedDebt(temp)
    } else if (!event.target.checked) {
      setSelectedDebt(0)
    }
  }
  const compareDates = (date1: string, date2: string) => {
    const parts1 = date1.split('.').reverse()
    const parts2 = date2.split('.').reverse()

    for (let i = 0; i < parts1.length; i++) {
      const num1 = parseInt(parts1[i])
      const num2 = parseInt(parts2[i])

      if (num1 < num2) {
        return -1
      } else if (num1 > num2) {
        return 1
      }
    }

    return 0
  }
  const handleSort = (column: keyof CustomerModelTahsilatModal) => {
    const newSortedData = bills.Detail
    let newSortOrder = 'asc'

    if (sortedColumn === column) {
      newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
    }

    newSortedData.sort((a: CustomerModelTahsilatModal, b: CustomerModelTahsilatModal) => {
      const valueA = a[column]
      const valueB = b[column]

      if (valueA === null && valueB === null) {
        return 0
      }

      if (valueA === null) {
        return 1
      }

      if (valueB === null) {
        return -1
      }

      if (column === 'NetVadeTarihi' || column === 'BelgeTarihi') {
        return newSortOrder === 'asc' ? compareDates(valueA, valueB) : compareDates(valueB, valueA)
      } else if (typeof valueA === 'number' && typeof valueB === 'number') {
        return newSortOrder === 'asc' ? valueA - valueB : valueB - valueA
      } else if (typeof valueA === 'string' && typeof valueB === 'string') {
        return newSortOrder === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
      } else {
        return 0
      }
    })

    setSortedData(newSortedData)
    setSortedColumn(column)
    setSortOrder(newSortOrder)
  }
  console.log('---->', bills)
  return (
    <div className={`card mt-2`}>
      {/* begin::Header */}

      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-0 mt-0'>
        {/* begin::Table container */}
        <div className='table-responsive card-scroll mh-250px '>
          {/* begin::Table */}
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted border-bottom border-primary'>
                <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      id='selectAll'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-13-check'
                      onChange={(e) => handleAll(e)}
                    />
                  </div>
                </th>
                <th className='min-w-150px modalHandle' onClick={() => handleSort('BelgeNo')}>
                  Fatura Numarası
                </th>
                <th className='min-w-140px modalHandle' onClick={() => handleSort('BelgeTarihi')}>
                  Fatura Tarihi
                </th>
                <th className='min-w-120px modalHandle' onClick={() => handleSort('NetVadeTarihi')}>
                  Net Vade Tarihi
                </th>
                <th className='min-w-120px modalHandle bg-secondary' onClick={() => handleSort('UpbTutar')}>
                  Tutar
                </th>
                <th className='min-w-120px modalHandle' onClick={() => handleSort('UpbTutar')}>
                  Tayın
                </th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody className='card-scroll mh-100px'>
              {bills === undefined && (
                <tr>
                  <td>
                    {' '}
                    <h1 className='text-center m-auto'>Yükleniyor...</h1>
                  </td>
                </tr>
              )}
              {bills !== undefined &&
                (bills.Status === 'SUCCESS' ? (
                  bills.Detail.map((bill: any, index: number) => (
                    <tr key={index}>
                      <td>
                        {' '}
                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input widget-13-check'
                            type='checkbox'
                            name='bills'
                            value={bill.UpbTutar}
                            onChange={(e) => handleSum(e)}
                          />
                        </div>
                      </td>
                      <td>
                        <span className='text-gray-800 fw-bold d-block mb-1 fs-6'>
                          {bill.BelgeNo}
                        </span>
                      </td>
                      <td>
                        <span className='text-gray-800 fw-bold d-block mb-1 fs-6 text-start'>
                          {bill.BelgeTarihi}
                        </span>
                      </td>
                      <td>
                        <span className='text-dark fw-bolder d-block mb-1 fs-6 text-center'>
                          {bill.NetVadeTarihi}
                        </span>
                      </td>
                      <td className='bg-secondary pe-2'>
                        <span className='text-danger fw-bolder d-block mb-1 fs-6 text-end'>
                          {bill.UpbTutar?.toLocaleString('tr-TR')} ₺
                        </span>
                      </td>
                      <td>
                        <span className='text-gray-800 fw-bold d-block mb-1 fs-6 text-end'>
                          {bill.Tayin?.toLocaleString('tr-TR')}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <></>
                ))}
            </tbody>

            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}

      <div className='card-header border-0 '>
        <div className='card-toolbar d-flex col-12 justify-content-between'>
          <span className='fw-bolder fs-7 border-bottom border-danger'>
            Toplam Borç:{' '}
            <span className='text-danger fw-bolder'>
              {customer.TotalBalance?.toLocaleString('tr-TR')} ₺
            </span>
          </span>

          <span className='fw-bolder fs-7 border-bottom border-danger'>
            Gecikmiş Borç{' '}
            <span className='text-danger fw-bolder'>
              {customer.TotalOverDue?.toLocaleString('tr-TR')} ₺
            </span>
          </span>

          <span className='fw-bolder fs-7 border-bottom border-danger'>
            Seçili Borç{' '}
            <span className='text-danger fw-bolder'>{selectedDebt?.toLocaleString('tr-TR')} ₺</span>
          </span>
          <span className='fw-bolder fs-7 border-bottom border-danger'>
            Kalan Borç{' '}
            <span className='text-danger fw-bolder'>
              {customer.TotalOverDue - selectedDebt < 0
                ? 0
                : (customer.TotalOverDue - selectedDebt)?.toLocaleString('tr-TR')}{' '}
              ₺
            </span>
          </span>
        </div>
      </div>
    </div>
  )
}

export default ModalBillTable
